import PropTypes from 'prop-types'
import { NotesTextArea } from "admin/views/members/member-profile/notes";
import { useRef } from 'react';
import SwitchMembershipSectionWrapper from '../section-wrapper';
import Icon from 'common/components/elements/icons';
import VariableList from 'common/components/modules/chat/variable-list';
import classNames from 'classnames';

import './index.scss'

const SwitchMembershipNotes = ({
   isMobile,
   title,
   onChange,
   showOnlyView,
   modalContentWrapperId,
   initialValue = '',
}) => {
   const textareaRef = useRef(null)

   const insertText = (text, bool) =>  {
      if(!text) return;
      if(textareaRef.current) {
         const quill = textareaRef.current.getEditor();
         const savedIndex = quill.selection?.savedRange?.index || 0
         if(bool){
            quill.insertText(savedIndex, text, 'user');
            quill.formatText(savedIndex, text.length, 'span', 'editor-variable', 'user');
            quill.setSelection(savedIndex + text.length, 0);
            quill.format('span', null);
            return
         }
         quill.insertText(savedIndex, text, 'user');
         quill.setSelection(savedIndex + text.length, 0);
      }
   }

   const view = (
      <div
         className={ classNames({
            'w-full member-note-content flex flex-col gap-2 ': true,
            'switch_membership_notes_wrapper': !showOnlyView,
         }) }
      >
         <div
            className='w-full flex flex-col gap-1'
         >
            <span
               className='text-major font-medium leading-5'
            >
               {title} <span className='text-xs leading-[15px] text-secondary font-normal'>(Optional)</span>
            </span>
            <div
               className='w-full flex justify-between items-end gap-3'
            >
               <div
                  className='flex gap-1 items-center'
               >
                  <div
                     className='flex w-5 h-5 min-w-[20px] items-center justify-center'
                  >
                     <Icon
                        name='unpublish'
                        color='secondary'
                        darkColor='secondary-dark'
                        size='lg'
                     />
                  </div>
                  <span
                     className='panel-description text-secondary'
                  >
                     Notes are visible only to you
                  </span>
               </div>
               <VariableList
                  variableList={ [
                     { text: '<previous-membership>' },
                     { text: '<new-membership>' },
                  ] }
                  onClickOpen={ () => {} }
                  name={ 'switch_membership_notes' }
                  selectorForTooltip='#tooltips'
                  selectVariable={ (text) => insertText(text, true) }
                  className='shrink-0'
                  doNotOpenListOnTooltip
                  scrollIntoViewOnOpenContent
               />
            </div>
         </div>
         <NotesTextArea
            currentNote={ initialValue }
            textareaRef={ textareaRef }
            isNew
            showDescription
            isMobile={ isMobile }
            onSetContent={ (html) => {
               onChange(html)

               const modalContentWrapperEl = document.getElementById(modalContentWrapperId)
               if(modalContentWrapperEl) {
                  const scrollTop = modalContentWrapperEl.scrollTop;

                  modalContentWrapperEl.scroll({
                     top: scrollTop,
                     left: 0,
                  });
               }
            } }
            onSave={ () => {} }
            hideSaveButton
            emojiContentXPositions={ {
               bottom: '34px',
               right: '0',
               top: 'auto',
            } }
            characterLimit={ 250 }
            placeholder='Add note'
         />
      </div>
   )

   if(showOnlyView) {
      return (
         view
      )
   }

   return (
      <SwitchMembershipSectionWrapper>
         {view}
      </SwitchMembershipSectionWrapper>
   )
}

SwitchMembershipNotes.propTypes = {
   isMobile: PropTypes.bool,
   title: PropTypes.string,
   onChange: PropTypes.func,
   showOnlyView: PropTypes.bool,
   initialValue: PropTypes.string,
   modalContentWrapperId: PropTypes.string,
}

export default SwitchMembershipNotes;
